document.addEventListener('DOMContentLoaded', () => {
  const navDataElement = document.getElementById('tiered-nav-data');
  const imageDataElement = document.getElementById('desktop-nav-image-data');

  if (!navDataElement) {
    console.warn('❌ Navigation HTML not found in DOM.');
    return;
  }

  const imageData = imageDataElement ? JSON.parse(imageDataElement.textContent) : {};
  const navData = extractNavFromDOM();
  console.log('✅ Loaded navData:', navData);

  const tier1Links = document.querySelectorAll('.tier-1-link-nav');
  const drawer = document.getElementById('desktop-nav-drawer');
  const overlay = drawer.querySelector('.drawer__overlay');
  const closeBtn = drawer.querySelector('.drawer__close');
  const tier2Container = drawer.querySelector('.tier-2-container');
  const tier3Container = drawer.querySelector('.tier-3-container');
  const tier2ImageContainer = drawer.querySelector('.tier-2-image-container');

  // 🔄 Position drawer below utility-bar + sticky header
  function setDrawerTopPosition() {
    const utilityBar = document.querySelector('.utility-bar');
    const stickyHeader = document.querySelector('sticky-header');

    let offset = 0;
    if (utilityBar) offset += utilityBar.offsetHeight;
    if (stickyHeader) offset += stickyHeader.offsetHeight;

    drawer.style.top = `${offset}px`;
  }

  // Initial set
  setDrawerTopPosition();
  // Update on scroll, resize, or layout change
  window.addEventListener('scroll', setDrawerTopPosition);
  window.addEventListener('resize', setDrawerTopPosition);

  tier1Links.forEach(link => {
  link.addEventListener('click', (e) => {
    const title = link.dataset.title.toLowerCase().trim();
    const navItem = navData.find(l => l.title.trim().toLowerCase() === title);

    if (navItem && navItem.links && navItem.links.length > 0) {
      e.preventDefault();
      openDrawer();
      renderTier2(navItem);
    } else if (navItem && navItem.url) {
      // Let normal link behavior proceed (i.e., do not preventDefault)
      link.setAttribute('href', navItem.url);
    } else {
      console.warn(`❌ Couldn't find valid Tier 1 item with title "${title}"`);
    }
  });
});

  if (closeBtn) {
    closeBtn.addEventListener('click', closeDrawer);
  } else {
    console.warn('❌ Close button not found');
  }

  function openDrawer() {
    setDrawerTopPosition(); // Recalculate position before showing
    drawer.classList.add('active');
    drawer.style.display = 'block';
    document.body.classList.add('no-scroll'); 
  }

  function closeDrawer() {
    drawer.classList.remove('active');
    drawer.style.display = 'none';
    document.body.classList.remove('no-scroll'); 
    tier2Container.innerHTML = '';
    tier3Container.innerHTML = '';
    tier2ImageContainer.innerHTML = '';
  }

  function renderTier2(item) {
    if (!item || !item.links) return;

    const tier2Html = item.links.map(link => `
      <li>
        <a href="#" class="tier-2-link" data-title="${link.title.toLowerCase().trim()}">
          ${link.title}
        </a>
      </li>
    `).join('');

    tier2Container.innerHTML = `<ul>${tier2Html}</ul>`;

    const tier2Links = drawer.querySelectorAll('.tier-2-link');

    tier2Links.forEach(link => {
  const title = link.dataset.title;
  const tier2Item = item.links.find(l => l.title.trim().toLowerCase() === title);

  link.addEventListener('mouseenter', () => {
    const imgUrl = imageData[title];
    tier2ImageContainer.innerHTML = imgUrl
      ? `<img src="${imgUrl}" alt="${title}" class="desktop-nav-image">`
      : '';
  });

  // 🧭 Click to either render tier3 or follow URL
  link.addEventListener('click', (e) => {
    if (tier2Item && tier2Item.links && tier2Item.links.length > 0) {
      e.preventDefault();
      renderTier3(tier2Item);
    } else if (tier2Item && tier2Item.url) {
      // Assign href just in case
      link.setAttribute('href', tier2Item.url);
    }
  });
});
  }

  function renderTier3(tier2Item) {
    if (!tier2Item || !tier2Item.links) {
      tier3Container.innerHTML = '';
      return;
    }

    const html = tier2Item.links.map(link => `
      <li><a href="${link.url}">${link.title}</a></li>
    `).join('');

    tier3Container.innerHTML = `<ul>${html}</ul>`;
  }

  function extractNavFromDOM() {
    const navRoot = document.querySelector('#tiered-nav-data ul');
    const items = [];

    if (!navRoot) return items;

    navRoot.querySelectorAll(':scope > li').forEach(tier1El => {
      const tier1 = {
        title: tier1El.dataset.title,
        url: tier1El.dataset.url,
        links: []
      };

      tier1El.querySelectorAll(':scope > ul.sub-links > li').forEach(tier2El => {
        const tier2 = {
          title: tier2El.dataset.title,
          url: tier2El.dataset.url,
          links: []
        };

        tier2El.querySelectorAll(':scope > ul.sub-sub-links > li').forEach(tier3El => {
          tier2.links.push({
            title: tier3El.dataset.title,
            url: tier3El.dataset.url
          });
        });

        tier1.links.push(tier2);
      });

      items.push(tier1);
    });

    return items;
  }
});